import * as types from './Types.js';

export function findAllParametros(idEntidade, idExercicio) {
  return ({ fetch }) => ({
    type: types.PARAMETRO_ALL,
    payload: fetch(`/parametros/${idEntidade}/${idExercicio}`)
  });
}
